import React from 'react';
import { createRoot } from 'react-dom/client';
import KollabDownloadOverlay from './KollabDownloadOverlay';
import type {
  KollabDownloadOverlayProps,
  KollabDownloadOverlayHandle,
} from './types';

declare global {
  interface Window {
    mountKollabDownloadOverlay: (
      containerId: string,
      props: KollabDownloadOverlayProps,
    ) => KollabDownloadOverlayHandle;
  }
}

window.mountKollabDownloadOverlay = function mountKollabDownloadOverlay(
  containerId: string,
  props: KollabDownloadOverlayProps,
): KollabDownloadOverlayHandle {
  const container = document.getElementById(containerId);
  if (!container) {
    console.error('KollabDownloadOverlay: container not found:', containerId);
    return { type: 'download-overlay', unmount: () => {} };
  }

  const root = createRoot(container);
  root.render(React.createElement(KollabDownloadOverlay, props));

  return {
    type: 'download-overlay',
    unmount: () => root.unmount(),
  };
};

export type {
  KollabDownloadOverlayProps,
  KollabDownloadOverlayHandle,
};
